export const getWin = () => (typeof window === 'undefined' ? {} : window)
export const getNotif = () =>
  typeof Notification === 'undefined' ? {} : Notification
